import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-c01-item-thumbnails-pc" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-the-c01-item-thumbnails-pc__sub" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.haveThumnails)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("img", {
            src: _ctx.main.image_url,
            class: "p-the-c01-item-thumbnails-pc__main"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnails, (sub, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "p-the-c01-item-thumbnails-pc__sub__panel",
                style: _normalizeStyle(_ctx.selectedStyle(sub)),
                onClick: ($event: any) => (_ctx.selectSub(sub))
              }, [
                _createElementVNode("img", {
                  src: sub.image_url
                }, null, 8, _hoisted_5)
              ], 12, _hoisted_4))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}